module.exports = __webpack_public_path__ + "static/media/bg21.6713dad5.jpg";